import React, { useRef } from 'react';
import cn from 'classnames';
import Button from 'chameleon/packages/blue-book-player/library/button';

const MenuItem = (props) => {
  const {
    label,
    children,
    onClick,
    accessibility,
    containerClass = '',
    labelClassName = '',
    selected,
  } = props;
  const buttonRef = useRef();

  return (
    <div className={`${containerClass} relative`}>
      <Button
        isNaked
        isRounded={false}
        size="custom"
        accessibility={accessibility}
        aria-label={label}
        onClick={onClick}
        aria-expanded={selected}
        ref={buttonRef}
        data-test-id="menu-item-button"
        data-cy="menu-item-button"
      >
        {children}
        <div
          aria-hidden="true"
          className={cn(
            'text-gray-900 text-[12px] font-medium leading-[1.75] whitespace-nowrap',
            {
              'border-b-2 border-bluebook-gray-900': selected,
            },
            labelClassName,
          )}
          data-test-id="menu-item-button-label"
          data-cy="menu-item-button-label"
        >
          {label}
        </div>
      </Button>
    </div>
  );
};

export default MenuItem;
